// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Source } from './Source';
import {
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
} from './Source';
import type { Token } from './Token';
import {
    TokenFromJSON,
    TokenFromJSONTyped,
    TokenToJSON,
} from './Token';
import type { TransactionContext } from './TransactionContext';
import {
    TransactionContextFromJSON,
    TransactionContextFromJSONTyped,
    TransactionContextToJSON,
} from './TransactionContext';
import type { TransactionType } from './TransactionType';
import {
    TransactionTypeFromJSON,
    TransactionTypeFromJSONTyped,
    TransactionTypeToJSON,
} from './TransactionType';

/**
 * 
 * @export
 * @interface TransactionEventNft
 */
export interface TransactionEventNft {
    /**
     * 
     * @type {string}
     * @memberof TransactionEventNft
     */
    seller: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEventNft
     */
    buyer: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionEventNft
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionEventNft
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionEventNft
     */
    fee: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionEventNft
     */
    signature: string;
    /**
     * 
     * @type {Source}
     * @memberof TransactionEventNft
     */
    source: Source;
    /**
     * 
     * @type {TransactionType}
     * @memberof TransactionEventNft
     */
    type: TransactionType;
    /**
     * 
     * @type {TransactionContext}
     * @memberof TransactionEventNft
     */
    saleType?: TransactionContext;
    /**
     * 
     * @type {Array<Token>}
     * @memberof TransactionEventNft
     */
    nfts: Array<Token>;
}

/**
 * Check if a given object implements the TransactionEventNft interface.
 */
export function instanceOfTransactionEventNft(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "seller" in value;
    isInstance = isInstance && "buyer" in value;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "fee" in value;
    isInstance = isInstance && "signature" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "nfts" in value;

    return isInstance;
}

export function TransactionEventNftFromJSON(json: any): TransactionEventNft {
    return TransactionEventNftFromJSONTyped(json, false);
}

export function TransactionEventNftFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionEventNft {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'seller': json['seller'],
        'buyer': json['buyer'],
        'timestamp': json['timestamp'],
        'amount': json['amount'],
        'fee': json['fee'],
        'signature': json['signature'],
        'source': SourceFromJSON(json['source']),
        'type': TransactionTypeFromJSON(json['type']),
        'saleType': !exists(json, 'saleType') ? undefined : TransactionContextFromJSON(json['saleType']),
        'nfts': ((json['nfts'] as Array<any>).map(TokenFromJSON)),
    };
}

export function TransactionEventNftToJSON(value?: TransactionEventNft | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'seller': value.seller,
        'buyer': value.buyer,
        'timestamp': value.timestamp,
        'amount': value.amount,
        'fee': value.fee,
        'signature': value.signature,
        'source': SourceToJSON(value.source),
        'type': TransactionTypeToJSON(value.type),
        'saleType': TransactionContextToJSON(value.saleType),
        'nfts': ((value.nfts as Array<any>).map(TokenToJSON)),
    };
}

